module.exports = "/images/lifestyle-change-background.png?172685bb3b74f8722b04dca399fd76bc";